import { TriangleAlert } from "lucide-react";
import { cn } from "../../lib/utils.ts";
import { Button } from "../ui/button.tsx";

export interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  retryLabel?: string;
  className?: string;
}

export function ErrorState({
  title = "Something went wrong",
  description = "Please try again in a moment.",
  onRetry,
  retryLabel = "Retry",
  className,
}: ErrorStateProps) {
  return (
    <div
      className={cn("flex flex-col items-center justify-center gap-3 py-12 text-center", className)}
      role="alert"
    >
      <TriangleAlert className="size-7 text-destructive" />
      <div className="space-y-1">
        <p className="font-display font-semibold text-base">{title}</p>
        <p className="mx-auto max-w-xs text-muted-foreground text-sm">{description}</p>
      </div>
      {onRetry ? (
        <Button variant="outline" size="sm" onClick={onRetry}>
          {retryLabel}
        </Button>
      ) : null}
    </div>
  );
}
